import { install } from 'resize-observer'

import 'core-js/features/string/replace-all'

install()
